var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "8px",
        height: "12px",
        viewBox: "0 0 8 12",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Presentatie",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Actueel-reacties",
                transform: "translate(-817.000000, -835.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group-10",
                    transform: "translate(0.000000, 148.000000)"
                  }
                },
                [
                  _c("g", { attrs: { id: "Group-3" } }, [
                    _c("rect", {
                      attrs: {
                        id: "Rectangle",
                        fill: "#05234F",
                        x: "0",
                        y: "0",
                        width: "1442",
                        height: "773"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Stacked-Group-2",
                          transform: "translate(600.000000, 673.000000)"
                        }
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "Group-3-Copy-2",
                              transform: "translate(200.000000, 0.000000)"
                            }
                          },
                          [
                            _c("g", { attrs: { id: "Group-8" } }, [
                              _c("circle", {
                                attrs: {
                                  id: "Oval",
                                  fill: "#FFFFFF",
                                  cx: "20",
                                  cy: "20",
                                  r: "20"
                                }
                              }),
                              _vm._v(" "),
                              _c("polyline", {
                                attrs: {
                                  id: "Path-4",
                                  stroke: "#05234F",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  points: "18 15 24 20 18 25"
                                }
                              })
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }